import { render, staticRenderFns } from "./TrfcInbound.vue?vue&type=template&id=5e666bef&"
import script from "./TrfcInbound.vue?vue&type=script&lang=js&"
export * from "./TrfcInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports